import { create } from "zustand";

import type { SessionUser } from "@/types/api";

/**
 * Access token faqat xotirada: XSS localStorage'dan o'g'irlay olmasin.
 * Sahifa yangilansa sessiya HttpOnly refresh cookie orqali tiklanadi
 * (`bootstrapped` — shu urinish tugadimi).
 */
interface AuthState {
  accessToken: string | null;
  user: SessionUser | null;
  bootstrapped: boolean;
  setSession: (session: { accessToken: string; user: SessionUser }) => void;
  clear: () => void;
  markBootstrapped: () => void;
}

export const useAuthStore = create<AuthState>(set => ({
  accessToken: null,
  user: null,
  bootstrapped: false,
  setSession: ({ accessToken, user }) => set({ accessToken, user, bootstrapped: true }),
  clear: () => set({ accessToken: null, user: null }),
  markBootstrapped: () => set({ bootstrapped: true }),
}));
